module.exports = __webpack_public_path__ + "static/bg.5ad899b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/rememberPrompt/bg.svg
// module id = 3677
// module chunks = 168707334958949